
















































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { EventService } from "@/services/eventService";
import { PublicVibrixEvent } from "@/interfaces/vibrixEvent";
import { DateService } from "@/services/dateService";
import EventDetailCard from "@/components/EventDetailCard.vue";
import { DataTableHeader } from "vuetify";

@Component({
    components: {
        EventDetailCard,
    },
})
export default class EventPublicCalendar extends Vue {
    @Prop() public ownerId!: string;
    @Prop() public providedStart?: string;

    $refs: {
        calendar: Vue & { title: string; prev: () => void; next: () => void };
    } = this.$refs;

    public loading: boolean = false;

    public events: PublicVibrixEvent[] = [];
    public get calendarEvents() {
        return this.events.map(e => ({
            ...e,
            start_time: DateService.formatDateForVCalendar(
                new Date(e.start_time)
            ),
            end_time: DateService.formatDateForVCalendar(new Date(e.end_time)),
        }));
    }

    public navigator = navigator;
    public calendarType: "month" | "day" = "month";
    public selectedMonth = new Date().toISOString().substring(0, 7);
    public selectedDay = new Date().toISOString().substring(8, 10);

    public selectedEvent: null | PublicVibrixEvent = null;
    public eventDetailDialog: boolean = false;

    public mounted() {
        if (this.providedStart) {
            this.selectedMonthDay = this.providedStart;
        }
    }

    public get selectedMonthDay() {
        return `${this.selectedMonth}-${this.selectedDay}`;
    }

    public set selectedMonthDay(v: string) {
        this.selectedMonth = v.substr(0, 7);
        this.selectedDay = v.substr(8, 10);
    }

    @Watch("ownerId", { immediate: true })
    public async loadPublicEvents(ownerId: string) {
        this.loading = true;
        try {
            this.events = await EventService.getPublicEvents(ownerId);
        } finally {
            this.loading = false;
        }
    }

    public onClickMore(e: { date: string }) {
        this.selectedMonthDay = e.date;
        this.calendarType = "day";
    }

    public onClickEvent(e: { event: PublicVibrixEvent }) {
        this.selectedEvent = e.event;
        this.eventDetailDialog = true;
    }

    public formatIsoString(string: string) {
        return DateService.formatIsoString(string, this.$i18n.locale);
    }

    public get eventHeaders(): DataTableHeader[] {
        return [
            {
                text: "Title",
                value: "title",
            },
            {
                text: "Start Date/Time",
                value: "start_time",
            },
            {
                text: "End Date/Time",
                value: "end_time",
            },
            {
                text: this.$t("event.toSignup").toString(),
                value: "actions",
            },
        ];
    }

    public determineEventColor(e: PublicVibrixEvent) {
        if (e.isFull) return "error";
        return e.is_private ? "secondary lighten-4" : "primary";
    }
}
